export default "__VITE_ASSET__710d6094__"